import React from 'react';
import Helmet from 'react-helmet';
//CSS
import './style.css';
//
export default function Page({ container: Container, component: Component, title, label, branding, menuList }){
    //Esse componente retorna uma página montada com seu Título na Aba do Navegador.
    //A lib Helmet modifica o metatag title da página, anterando assim o título da aba.
    //O Container recebe o conteúdo da página.
    return class Page extends React.Component {
        render() {
            return (
                <>
                    <Helmet>
                        <title>{label}</title>
                    </Helmet>
                    <Container menuList={menuList} pageTitle={title} branding={branding} {...this.props}>
                        <Component pageTitle={title} branding={branding} {...this.props}/>
                    </Container>
                </>
            );
        }
    };
};